import { render } from "./FooterComponent.vue?vue&type=template&id=ba234b06"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Unimagem\\diaMundialdoRim\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__